import { render } from "./FrmExpeditionDocumentAddPale.vue?vue&type=template&id=49e22c95"
import script from "./FrmExpeditionDocumentAddPale.vue?vue&type=script&lang=js"
export * from "./FrmExpeditionDocumentAddPale.vue?vue&type=script&lang=js"

import "./FrmExpeditionDocumentAddPale.vue?vue&type=style&index=0&id=49e22c95&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__